export const LOAD_DOCUMENT_RIGHTS_SUCCESS = "LOAD_DOCUMENT_RIGHTS_SUCCESS";
